import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
} from 'reactstrap';
import { toast } from 'react-toastify';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import BusinessApi from 'apis/Business';
import { YELP, GOOGLEREVIEWS, TRIPADVISOR } from 'constants/SocialMedias';

import SocialMediaConfig from './social-media/SocialMediaConfig';
import SocialMediaMessage from './social-media/SocialMediaMessage';
import Toaster from '../../../Toaster';

const DEFAULT_MESSAGE = `We here at {businessName} appreciate the review you left on our survey.
 We would be thrilled if you give us a 5 star rating on the sites below!`;

class OtherMediaAddOnModal extends Component {
  constructor() {
    super();
    this.state = {
      yelpActive: false,
      tripadvisorActive: false,
      googleReviewsActive: false,
      yelp: {},
      google_reviews: {},
      tripadvisor: {},
      customMessage: '',
    };
  }

  componentDidMount() {
    const { data, socialReviewAddon, businessName } = this.props;

    const yelpData = data.find(dt => dt.review_type === YELP.type);
    const googleReviewsData = data.find(
      dt => dt.review_type === GOOGLEREVIEWS.type
    );
    const tripadvisorData = data.find(
      dt => dt.review_type === TRIPADVISOR.type
    );
    const { custom_message } = socialReviewAddon || {};
    const customMessage = custom_message
      ? custom_message
      : DEFAULT_MESSAGE.replace('{businessName}', businessName);
    this.setState({
      yelp: yelpData || {},
      google_reviews: googleReviewsData || {},
      tripadvisor: tripadvisorData || {},
      yelpActive: yelpData ? yelpData.is_active : false,
      tripadvisorActive: tripadvisorData ? tripadvisorData.is_active : false,
      googleReviewsActive: googleReviewsData
        ? googleReviewsData.is_active
        : false,
      customMessage,
    });
  }

  activateYelp = () => {
    this.setState(prevState => ({
      yelpActive: !prevState.yelpActive,
    }));
  };

  activateGoogleReviews = () => {
    this.setState(prevState => ({
      googleReviewsActive: !prevState.googleReviewsActive,
    }));
  };

  activateTripadvisor = () => {
    this.setState(prevState => ({
      tripadvisorActive: !prevState.tripadvisorActive,
    }));
  };

  updateContent = (type, data) => {
    this.setState({
      [type]: data,
    });
  };

  save = () => {
    const { yelp, google_reviews, tripadvisor } = Object.assign(this.state, {});
    const {
      yelpActive,
      googleReviewsActive,
      tripadvisorActive,
      customMessage,
    } = this.state;

    yelp.is_active = yelpActive;
    google_reviews.is_active = googleReviewsActive;
    tripadvisor.is_active = tripadvisorActive;

    const { businessId, toggleModal, socialReviewAddon } = this.props;
    const { id: socialReviewAddonId } = socialReviewAddon || {};

    const socialReviewsAttributes = [yelp, google_reviews, tripadvisor].filter(
      x => Object.keys(x).length > 1 && x.title && x.link
    );

    const businessAddonsAttributes = [
      {
        id: socialReviewAddonId,
        custom_message: customMessage || '',
      },
    ];

    if (socialReviewsAttributes.length < 1) return;

    const updatedData = {
      business: {
        social_reviews_attributes: socialReviewsAttributes,
        business_addons_attributes: businessAddonsAttributes,
      },
    };

    BusinessApi.update(businessId, updatedData)
      .then(() => {
        toggleModal();
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" /> Successfully updated
            configuration.
          </div>
        ));
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" /> Error while
              fetching data
            </div>
          )),
          console.log(e)
        )
      );
  };

  onCustomMessageChange = message => {
    const { customMessage } = this.state;
    const { businessId, socialReviewAddon } = this.props;
    const { id: socialReviewAddonId } = socialReviewAddon || {};
    const businessAddonsAttributes = [
      {
        id: socialReviewAddonId,
        custom_message: message,
      },
    ];
    const updatedData = {
      business: {
        business_addons_attributes: businessAddonsAttributes,
      },
    };
    BusinessApi.update(businessId, updatedData)
      .then(() => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Custom Message Updated Successfully'
        );
        this.setState({ customMessage: message });
      })
      .catch(e => {
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to update custom message'
        );
        this.setState({ customMessage });
      });
  };

  render() {
    const { toggleModal, isVisible, title, type } = this.props;
    const {
      yelp,
      google_reviews,
      tripadvisor,
      customMessage,
      yelpActive,
      googleReviewsActive,
      tripadvisorActive,
    } = this.state;

    return (
      <React.Fragment>
        <Modal className="select-metrics-modal" isOpen={isVisible}>
          <ModalHeader toggle={toggleModal}>
            <div className="metric-title">
              <span className="w-100 float-left">Review Sites add-ons</span>
            </div>
          </ModalHeader>

          <ModalBody>
            <SocialMediaMessage
              onCustomMessageChange={this.onCustomMessageChange}
              type={type}
              message={customMessage}
            />
            <SocialMediaConfig
              data={YELP}
              showSocialMedia={yelpActive}
              toggleSocialMedia={this.activateYelp}
              updateContent={this.updateContent}
              type={type}
              values={yelp}
            />
            <SocialMediaConfig
              data={GOOGLEREVIEWS}
              showSocialMedia={googleReviewsActive}
              toggleSocialMedia={this.activateGoogleReviews}
              updateContent={this.updateContent}
              type={type}
              values={google_reviews}
            />
            <SocialMediaConfig
              data={TRIPADVISOR}
              showSocialMedia={tripadvisorActive}
              toggleSocialMedia={this.activateTripadvisor}
              updateContent={this.updateContent}
              type={type}
              values={tripadvisor}
            />
          </ModalBody>
          <ModalFooter className="d-block">
            <ButtonGroup className="float-right">
              <Button className="btn-cancel" onClick={toggleModal}>
                Cancel
              </Button>
              <Button className="btn-success" onClick={this.save}>
                Save Network
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

OtherMediaAddOnModal.defaultProps = {
  toggleModal: () => {},
  isVisible: false,
};

OtherMediaAddOnModal.propTypes = {
  toggleModal: PropTypes.func,
  isVisible: PropTypes.bool,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired,
  socialReviewAddon: PropTypes.shape({
    id: PropTypes.number,
    custom_message: PropTypes.string,
  }).isRequired,
};

export default OtherMediaAddOnModal;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/info-edit/OtherMediaAddOnModal.js